import { I18nMessage, usePathname } from "@i18n/next";
import { Text } from "@packages/ui";

type PathConfig = {
  path: string;
  messageKey: string;
};

const PATH_CONFIGS: PathConfig[] = [
  {
    path: "settings/group-info",
    messageKey: "community_settings_group_info",
  },
  {
    path: "settings/permissions",
    messageKey: "community_settings_permissions",
  },
  {
    path: "members",
    messageKey: "community_settings_members",
  },
  {
    path: "groups",
    messageKey: "community_detail_groups_screen_title",
  },
  {
    path: "giving",
    messageKey: "giving_title",
  },
  {
    path: "classes",
    messageKey: "general_word_classes",
  },
];

const DEFAULT_MESSAGE_KEY = "web_dashboard";

export const AdminPageTitle = () => {
  const pathname = usePathname();

  const messageKey =
    PATH_CONFIGS.find((config) => pathname.includes(config.path))?.messageKey ||
    DEFAULT_MESSAGE_KEY;

  return (
    <Text size="xl" type="title">
      <I18nMessage message={messageKey} />
    </Text>
  );
};

AdminPageTitle.displayName = "AdminPageTitle";
